import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  signal,
  ViewContainerRef,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { JobsService } from '../../../pages/pages/jobs/jobs.service';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import { getMultiSelectSearchValue } from '../../../../global.variable';
import { ClientsService } from '../../../pages/pages/clients/clients.service';

@Component({
  selector: 'gtapp-data-filter',
  standalone: false,
  templateUrl: './data-filter.component.html',
  styleUrl: './data-filter.component.scss',
})
export class DataFilterComponent {
  trackByColumn = (_: number, col: any) => col?.name;
  tableColumns = signal<any>([]);
  indColumn = signal<any>({});

  isIndColumn: boolean = false;

  @Output() updateParent = new EventEmitter();

  @Input() set tableColumnsInput(value: any) {
    this.tableColumns.set(value);
    this.isIndColumn =
      this.indColumn() && Object.keys(this.indColumn())?.length;
  }

  @Input() set indColumnInput(value: any) {
    this.indColumn.set(value);
    this.isIndColumn =
      this.indColumn() && Object.keys(this.indColumn())?.length;
  }

  autoCompleteSearchResultList: any = [];
  selectedDropDownItem: any;

  constructor(
    private dialogService: ModalDialogueService,
    private viewContainerRef: ViewContainerRef,
    private jobService: JobsService,
    private cdr: ChangeDetectorRef,
    private clientService: ClientsService,
  ) {}
  async openAllFilters(template: any) {
    const dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (res) {
      this.updateParent.emit({
        cols: this.tableColumns(),
        action: 'updateTableCols',
      });
    }
  }
  onAutoCompleteInputSearch(event: any, selectedCol: any) {
    const searchStr = event?.target?.value || '';
    if (searchStr && searchStr?.length <= 2) return;
    switch (selectedCol?.autoComplete) {
      case 'user':
        this.getAssignees({ search_str: searchStr });
        break;
      case 'site':
        this.siteLookupApi(searchStr, selectedCol);
        break;
    }
  }

  getAssignees(params?: any) {
    this.jobService.getUserList(params).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.autoCompleteSearchResultList = response?.data || [];
        this.cdr.detectChanges();
      }
    });
  }

  siteLookupApi(searchStr?: any, selectedCol?: any) {
    if (selectedCol?.autoCompleteFilter?.company_id) {
      // mainly for prime contractor user; should only lookup sites belonging to a particular client
      let params: any = {
        company: selectedCol?.autoCompleteFilter?.company_id,
        rows: 10,
        search_str: searchStr,
      };

      this.clientService.getSiteList(params).subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.autoCompleteSearchResultList = response?.data;
          this.cdr.detectChanges();
        }
      });
    } else {
      this.clientService
        .searchSites({
          search_str: searchStr,
          is_active: 1,
        })
        .subscribe((res: any) => {
          if (res['status'] == 'success') {
            this.autoCompleteSearchResultList = (res?.data || [])?.splice(
              0,
              10,
            );
            this.cdr.detectChanges();
          }
        });
    }
  }

  onAutoCompleteItemSelect(event: any, selectedCol: any) {
    if (typeof event === 'string') {
      selectedCol.searchString = event;
    } else {
      switch (selectedCol?.autoComplete) {
        case 'user':
          selectedCol.searchString = event?.full_name;
          selectedCol.autoCompleteSelectedId = event?.id;
          break;
        case 'site':
          selectedCol.searchString = event?.company_name;
          selectedCol.autoCompleteSelectedId = event?.id;
          break;
      }
    }
    if (selectedCol?.searchString) {
      this.searchField(selectedCol);
    }
  }
  searchField(column: any) {
    const updatedColumns = this.tableColumns()?.map((col: any) =>
      col === column
        ? {
            ...col,
            searchValue: col.searchString,
            searchString: null,
            openSearchBox: false,
          }
        : col,
    );

    this.tableColumns.set(updatedColumns);
    if (this.isIndColumn) {
      this.updateParent.emit({
        cols: this.tableColumns(),
        action: 'updateTableCols',
      });
    }

    // this.applyFilters();
  }
  onSelectDropDownItem(event: any, column: any) {
    column.opendropDownBox = false;
  }
  onSelectMultipleSelectOptions(column: any, item: any) {
    let selectedItems = [...(column?.selectedItems ?? [])];
    if (selectedItems?.includes(item?.id)) {
      selectedItems = selectedItems.filter((id: any) => id !== item?.id);
    } else {
      selectedItems = [...selectedItems, item?.id];
    }
    column.selectedItems = selectedItems;

    const updatedColumns = this.tableColumns()?.map((col: any) =>
      col === column
        ? {
            ...col,
            searchValue: column?.selectedItems?.length
              ? getMultiSelectSearchValue(column)
              : '',
            searchString: null,
            openSearchBox: false,
            selectedItems: selectedItems,
          }
        : col,
    );

    this.tableColumns.set(updatedColumns);
    if (this.isIndColumn) {
      this.updateParent.emit({
        cols: this.tableColumns(),
        action: 'updateTableCols',
      });
    }
  }
  onChangeDateTime(event: any, column: any) {
    if (event?.start && event?.end) {
      column.searchValue = event;
      const updatedColumns = this.tableColumns()?.map((col: any) =>
        col === column
          ? {
              ...col,
              searchValue: col.searchValue,
              searchString: null,
              openSearchBox: false,
            }
          : col,
      );

      this.tableColumns.set(updatedColumns);
    }
  }
  removeFilter(column: any) {
    const updatedColumns = this.tableColumns()?.map((col: any) =>
      col === column
        ? {
            ...col,
            searchValue: null,
            searchString: null,
            openSearchBox: false,
          }
        : col,
    );

    this.tableColumns.set(updatedColumns);
  }
  shouldDisableApplyBtn() {
    return this.tableColumns()?.some(
      (col: any) => col?.isFilterRequired && !col?.searchValue,
    );
  }
}
